<template>
  <section>
    <div class="Customer">
      <div class="customerHeader"><span>最新</span>客户案例</div>
      <div class="customerDescription">快速提高网站排名，获取精准流量，网站不再是摆设</div>
      <div class="customerDetail clean">
        <div class="customerDetailLeft">
          <div class="caseTitle clean">
            <div class="caseIcon"></div>
            <div class="caseDesc">最新案例</div>
          </div>
          <div class="caseDetail">
            <table>
              <tr class='title'>
                <th style='white-space: nowrap;font-size: 14px;'>客户网址</th>
                <th style='white-space: nowrap;font-size: 14px;'>关键字</th>
                <!--<th style='white-space: nowrap;font-size: 14px;'>搜索引擎</th>-->
                <th style='white-space: nowrap;font-size: 14px;'>初排名</th>
                <th style='white-space: nowrap;font-size: 14px;'>现排名</th>
              </tr>
              <tr class='list' v-for='item in detailList1' :key='item.id'>
                <td style='font-size: 13px;'>{{item.url}}</td>
                <td style='font-size: 13px;'>{{item.key}}</td>
                <!--<td style='font-size: 13px;'>{{item.engine_type}}</td>-->
                <td style='font-size: 13px;'>{{item.de_pm}}</td>
                <td style='font-size: 13px;'>{{item.pm}}</td>
              </tr>
              <!--<tr class='list' >
                <td>www.hbxuanshi.com</td>
                <td>球墨铸铁管</td>
                <td>58</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.03315.cn</td>
                <td>上海搬家公司</td>
                <td>58</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.kzssypf.com</td>
                <td>医用口罩</td>
                <td>30</td>
                <td>1</td>
              </tr><tr class='list' >
                <td>www.hanchengbaojie.cn</td>
                <td>青岛保洁</td>
                <td>0</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.tiebaobei.com</td>
                <td>二手挖掘机</td>
                <td>97</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.fujte.com</td>
                <td>集成墙板</td>
                <td>60</td>
                <td>1</td>
              </tr><tr class='list' >
                <td>www.mqhu.com</td>
                <td>狐臭</td>
                <td>23</td>
                <td>5</td>
              </tr><tr class='list' >
                <td>www.fintechonex.com</td>
                <td>区块链交易所</td>
                <td>18</td>
                <td>4</td>
              </tr><tr class='list' >
                <td>www.cailianfu.com</td>
                <td>刷脸支付</td>
                <td>82</td>
                <td>10</td>
              </tr><tr class='list' >
                <td>fitness.pclady.com.cn</td>
                <td>脱发</td>
                <td>76</td>
                <td>2</td>
              </tr><tr class='list' >
                <td>www.jianshe99.com</td>
                <td>二级建造师</td>
                <td>98</td>
                <td>8</td>
              </tr><tr class='list' >
                <td>www.chinacaos.com</td>
                <td>弯管机</td>
                <td>23</td>
                <td>4</td>
              </tr><tr class='list' >
                <td>www.xinkean.com</td>
                <td>按摩椅</td>
                <td>0</td>
                <td>4</td>
              </tr><tr class='list' >
                <td>www.xinkean.com</td>
                <td>呼叫中心</td>
                <td>44</td>
                <td>2</td>
              </tr><tr class='list' >
                <td>www.kqwad.com</td>
                <td>南京广告制作</td>
                <td>20</td>
                <td>2</td>
              </tr><tr class='list' >
                <td>www.zjszkj.cn</td>
                <td>商标注册</td>
                <td>28</td>
                <td>2</td>
              </tr><tr class='list' >
                <td>www.naturalbreath.net</td>
                <td>胶原蛋白</td>
                <td>98</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.tphoto.cn</td>
                <td>婚纱照</td>
                <td>32</td>
                <td>3</td>
              </tr><tr class='list' >
                <td>www.aqe-pet.com</td>
                <td>宠物医院</td>
                <td>0</td>
                <td>10</td>
              </tr><tr class='list' >
                <td>www.xiananxin.com</td>
                <td>月子中心</td>
                <td>11</td>
                <td>3</td>
              </tr>-->
            </table>
          </div>
        </div>
        <div class="customerDetailLeft">
          <div class="caseTitle clean">
            <div class="caseIcon"></div>
            <div class="caseDesc">最新充值</div>
          </div>
          <div class="caseDetail">
            <table>
              <tr class='title'>
                <th style='white-space: nowrap;font-size: 14px;'>用户名</th>
                <th style='white-space: nowrap;font-size: 14px;'>手机号</th>
                <th style='white-space: nowrap;font-size: 14px;'>充值金额</th>
                <th style='white-space: nowrap;font-size: 14px;'>充值时间</th>
              </tr>
              <tr class='list' v-for='item in detailList2' :key='item.id'>
                <td style='font-size: 13px;'>{{item.username}}</td>
                <td style='font-size: 13px;'>{{item.mobile}}</td>
                <td style='font-size: 13px;'>{{item.number}}</td>
                <td style='font-size: 13px;'>{{item.time}}</td>
              </tr>
              <!--<tr class='list'>
                <td>njjj7825</td>
                <td>1581****106</td>
                <td>1000</td>
                <td>2020-4-11 22:56:52</td>
              </tr><tr class='list'>
                <td>szjg123</td>
                <td>1512****231</td>
                <td>500</td>
                <td>2020-4-11 22:50:46</td>
              </tr><tr class='list'>
                <td>aduer</td>
                <td>1332****588</td>
                <td>1000</td>
                <td>2020-4-11 22:31:45</td>
              </tr><tr class='list'>
                <td>11fujte11</td>
                <td>1771****216</td>
                <td>1000</td>
                <td>2020-4-11 22:24:15</td>
              </tr><tr class='list'>
                <td>sj1510</td>
                <td>1521****656</td>
                <td>1000</td>
                <td>2020-4-11 22:21:46</td>
              </tr><tr class='list'>
                <td>ptj000</td>
                <td>1352****425</td>
                <td>3000</td>
                <td>2020-4-11 22:16:45</td>
              </tr><tr class='list'>
                <td>lhydj666</td>
                <td>1361****565</td>
                <td>5000</td>
                <td>2020-4-11 21:58:13</td>
              </tr><tr class='list'>
                <td>jzif</td>
                <td>1395****023</td>
                <td>3000</td>
                <td>2020-4-11 21:33:23</td>
              </tr><tr class='list'>
                <td>841888</td>
                <td>1561****015</td>
                <td>2000</td>
                <td>2020-4-11 21:28:56</td>
              </tr><tr class='list'>
                <td>yuan588</td>
                <td>1786****156</td>
                <td>5000</td>
                <td>2020-4-11 21:21:06</td>
              </tr><tr class='list'>
                <td>active</td>
                <td>1385****378</td>
                <td>2000</td>
                <td>2020-4-11 21:20:28</td>
              </tr><tr class='list'>
                <td>lanfu88</td>
                <td>1395****456</td>
                <td>1000</td>
                <td>2020-4-11 21:17:25</td>
              </tr><tr class='list'>
                <td>who123</td>
                <td>1761****723</td>
                <td>3000</td>
                <td>2020-4-11 21:16:56</td>
              </tr><tr class='list'>
                <td>szjiagnuang</td>
                <td>1862****042</td>
                <td>500</td>
                <td>2020-4-11 21:11:35</td>
              </tr><tr class='list'>
                <td>561956</td>
                <td>1875****482</td>
                <td>1000</td>
                <td>2020-4-11 21:07:26</td>
              </tr>-->
            </table>
          </div>
        </div>
      </div>
      <div class="process">爱排名合作流程<span>简单七步</span></div>
      <div class='step'>
        <img src="../assets/images/stepBg.png" alt="">
        <p class="line"></p>
        <ul class='stepList'>
          <li class='list'>
            <i class="iconfont icon-zu18"></i>
            <p>Step1.</p>
            <p>注册</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu19"></i>
            <p>Step2.</p>
            <p>诊断</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu18"></i>
            <p>Step3.</p>
            <p>选择服务</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu19"></i>
            <p>Step4.</p>
            <p>后台充值</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu18"></i>
            <p>Step5.</p>
            <p>提交关键词</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu19"></i>
            <p>Step6.</p>
            <p>开始优化</p>
          </li>
          <li class='list'>
            <i class="iconfont icon-zu18"></i>
            <p>Step7.</p>
            <p>效果监控</p>
          </li>
        </ul>
      </div>
      <div class="contact">
        <div class="contactTitle"><span>联系</span><span>我们</span></div>
        <div class="contactDetail">
          <div class="contactLeft">
            <div class="contactLeft1">
              <div class="contactLogo"><img src="../assets/images/logo1.png" width="146" height="34"></div>
              <div class="companyName">{{business_name}}</div>
              <div class="contactPhoneNumber clean">
                <div><img src="../assets/images/small_phone.png" width="14" height="14"></div>
                <div>{{free_hotline}}</div>
              </div>
              <!-- <div class="contactPhoneNumber clean">
                <div></div>
                <div style='margin-left: 14px;'>400-1616-115</div>
              </div> -->
              <div class="contactPhoneNumber clean">
                <div><img src="../assets/images/qq.png" width="14" height="14"></div>
                <div>{{qq}}</div>
              </div>
              <div class="contactPhoneNumber clean">
                <div><img src="../assets/images/wechat.png" width="14" height="14"></div>
                <div>{{weixin}}</div>
              </div>
              <div class="contactPhoneNumber clean">
                <div><img src="../assets/images/paint.png" width="14" height="14"></div>
                <div>{{fax}}</div>
              </div>
              <div class="contactPhoneNumber clean">
                <div><img src="../assets/images/circled.jpg" width="14" height="14"></div>
                <div>{{business_address}}</div>
              </div>
            </div>
            <div class="contactLeft2">
              <div class="ercode">
                <img :src="wximage" style='width: 80px;'>
                <p>【微信扫码咨询】</p>
              </div>
              <div class="ercode">
                <img :src="qqimage" style='width: 80px;'>
                <p>【QQ扫码咨询】</p>
              </div>
            </div>
          </div>
          <div class="contactRight">
            <div class="contactNumber">
              <el-input placeholder="*公司名字" v-model='companyName'></el-input>
            </div>
            <div class="contactNumber">
              <el-input placeholder="*手机号" v-model='phoneNum'></el-input>
            </div>
            <div class="qq">
              <el-input placeholder="QQ" v-model='qqNo'></el-input>
            </div>
            <div class="wx">
              <el-input placeholder="微信" v-model='wechart'></el-input>
            </div>
            <div class="site">
              <el-input placeholder="请填写您的网址（为您提供SEO诊断）" v-model='webUrl'></el-input>
            </div>
            <div class="tips">*为方便我们快速联系到您，请如实填写以下信息，谢谢！</div>
            <div class="submit" @click='addMessage'>提 交</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { Api } from '../service/api'
import { Message } from 'element-ui';
  export default {
    name: 'NewestCase',
    data() {
      return {
        logo: '',               // 网站logo
        business_name: '',      // 公司名称
        business_address: '',   // 公司地址
        free_hotline: '',       // 	免费热线
        fax: '',                // 	传真
        qq: '',                 // 官方qq
        weixin: '',             // 官方微信
        wximage: '',            // 微信扫码咨询
        qqimage: '',            // 	qq扫码咨询
        userName: '',
        companyName: '',
        phoneNum: '',
        qqNo: '',
        wechart: '',
        webUrl: '',
        detailList1: [],
        detailList2: []
      }
    },
    methods: {
      setSite() {
        let params = {

        }
        Api.setSite(params).then((res) => {
          this.logo = res.data.data.logo;               // 网站logo
          this.business_name = res.data.data.business_name;      // 公司名称
          this.business_address = res.data.data.business_address;   // 公司地址
          this.free_hotline = res.data.data.free_hotline;       // 	免费热线
          this.fax = res.data.data.fax;                // 	传真
          this.qq = res.data.data.qq;                 // 官方qq
          this.weixin = res.data.data.weixin;            // 官方微信
          this.wximage = res.data.data.wximage;            // 微信扫码咨询
          this.qqimage = res.data.data.qqimage;            // 	qq扫码咨询
        })
      },
      getStatistics() {
        let params = {
          id: ''
        }
        Api.getStatistics(params).then((res) => {
          for(let i=0; i< res.data.data.new_case.lenngth; i++) {

          }
          for(let m=0; m< res.data.data.recharge.length; m++) {
            let date = res.data.data.recharge[m].create_time * 1000;
            let year = new Date(date).getFullYear();
            let month = new Date(date).getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            let day = new Date(date).getDate()
            day = day < 10 ? "0" + day : day;
            console.log(day)
            let hour = new Date(date).getHours()
            hour = hour < 10 ? "0" + hour : hour;
            let minute = new Date(date).getMinutes()
            minute = minute < 10 ? "0" + minute : minute;
            let second = new Date(date).getSeconds()
            second = second < 10 ? "0" + second : second;
            res.data.data.recharge[m].time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
          }
          this.detailList1 = res.data.data.new_case || []
          this.detailList2 = res.data.data.recharge || []
        })
      },
      addMessage() {
        if(!this.companyName){
          Message({
            showClose: true,
            message: '请填写公司名称',
            type: 'success'
          })
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.phoneNum))){
          Message({
            showClose: true,
            message: '请填写正确的手机号码',
            type: 'success'
          })
          return
        }
        let params = {
          name: this.userName,
          mobile: this.phoneNum,
          company_name: this.companyName,
          qq: this.qqNo,
          wechat: this.wechart,
          url: this.webUrl
        }
        Api.addMessage(params).then((res) => {
          console.log(res.data)
          Message({
            showClose: true,
            message: res.data.msg,
            type: 'success'
          })
            this.username = ''
            this.phoneNum = ''
            this.companyName = ''
            this.qqNo = ''
            this.wechart = ''
            this.webUrl =  ''
        })
      }
    },
    mounted() {
      this.getStatistics()
      this.setSite()
    }
  }
</script>
<style lang='scss' scoped>
  .Customer{
    padding-top: 50px;
    .customerHeader{
      margin: 0 2.5rem;
      width: 288px;
      height: 55px;
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 55px;
      color: rgba(31,33,45,1);
      opacity: 1;
      margin: auto;
      span{
        color: #FC5F35;
      }
    }
    .customerDescription{
      margin: 0 2.5rem;
      width: 460px;
      height: 23px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 23px;
      color: rgba(112,112,112,1);
      opacity: 0.5;
      margin: auto;
      margin-top: 23px;
    }
    .customerDetail{
      margin: 49px 2.5rem 0;
      display: flex;
      .customerDetailLeft {
        float: left;
        width: 46%;
        &:nth-of-type(2){
          margin-left: 6%;
        }
        .caseIcon, .RechargeIcon{
          float: left;
          width: 10px;
          height: 23px;
          background: url(../assets/images/case.png);
          background-size: 100% 100%;
          opacity: 1;
          margin-top: 6px;
        }
        .caseDesc, .RechargeDesc{
          float: left;
          width: 120px;
          height: 35px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 35px;
          color: rgba(252,95,53,1);
          opacity: 1;
          margin-left: 8px;
          text-align: left;
        }
        .caseDetail{
          width: 100%;
          border-radius: 8px 8px 0px 0px;
          margin-top: 13px;
          padding: 0;
          border: 0;
          border-collapse: collapse;
          border-spacing: 0;
          border-radius: 10px;
          .title{
            background:#40485c;
            line-height: 45px;
            height: 45px;
            color: #fff;
            border-radius: 10px;
          }
          .list{
            line-height: 28px;
            height: 28px;
            color: #777;
            &:nth-of-type(odd){
              background: #eaeaea;
            }
          }
        }
      }
    }
    table{
      width: 100%;
      margin: 0 2.5rem;
      padding: 0;
      border: 0;
      border-collapse: collapse;
      border-spacing: 0;
      margin: 0 auto;
      .list{
        &:hover{
          cursor: pointer;
          td{
            color: #fc5f35;
          }
        }
      }
    }
    .clean{
      clear: both;
      overflow: hidden;
    }
    .process{
      font-size: 34px;
      height: 120px;
      line-height: 120px;
      span{
        color: #fc5f35;
      }
    }
    .step{
      position: relative;
      left: 0;
      top: 0;
      z-index: 20;
      img{
        width: 100%;
        height: auto;
      }
      .line{
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 30;
        width: 100%;
        height: 2px;
        background: #FC5F35;
        margin-top: 5px;
      }
      .stepList{
        position: absolute;
        left: 12%;
        top: 0;
        display: flex;
        width: 76%;
        height: 100%;
        .list{
          width: 14.3%;
          position: absolute;
          left: 0;
          top: 50%;
          i{
            color: #FC5F35;
            font-size: 60px;
          }
          p{
            color: #fff;
            line-height: 28px;
            position: absolute;
            width: 100%;
            text-align: center;
            &:nth-of-type(1){
              font-size: 15px;
            }
            &:nth-of-type(2){
              font-size: 20px;
              font-weight: 600;
            }
          }
          &:nth-of-type(odd){
            transform: translateY(-12px);
            p:nth-of-type(1){
              bottom: -22px;
            }
            p:nth-of-type(2){
              bottom: -46px;
            }
          }
          &:nth-of-type(even){
            transform: translateY(-41px);
            p:nth-of-type(1){
              top: -25px;
            }
            p:nth-of-type(2){
              top: -50px;
            }
          }
          &:nth-of-type(1){
            left: 0;
          }
          &:nth-of-type(2){
            left: 14.3%;
          }
          &:nth-of-type(3){
            left: 28.6%;
          }
          &:nth-of-type(4){
            left: 42.9%;
          }
          &:nth-of-type(5){
            left: 57.2%;
          }
          &:nth-of-type(6){
            left: 71.5%;
          }
          &:nth-of-type(7){
            left: 85.8%;
          }
        }
      }
    }
    .contact{
      margin: 50px 2.5rem 0;
      background: #f7f7f7;
      .contactTitle{
        width: 192px;
        height: 64px;
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 64px;
        color: rgba(31,35,38,1);
        opacity: 1;
        margin: auto;
        span:last-child{
          font-weight: 200;
        }
      }
      .contactDetail{
        width: 100%;
        margin-top: 60px;
        display: flex;
        .contactLeft{
          width: 45%;
          padding-bottom: 40px;
          background: rgba(255,255,255,1);
          box-shadow: 0px 3px 20px rgba(0,0,0,0.05);
          opacity: 1;
          padding-top: 35px;
          padding-left: 15px;
          display: flex;
          position: relative;
          left: 0;
          top: 0;
          .contactLeft1{
            .companyName {
              width: 300px;
              height: 17px;
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 20px;
              color: rgba(54,54,54,1);
              opacity: 1;
              margin-top: 32px;
            }
            .contactPhoneNumber {
              margin-top: 16px;
              font-size: 16px;
              text-align: left;
              line-height: 32px;
              display: flex;
              div:nth-of-type(1){
                margin-right: 10px;
              }
            }
          }
          .contactLeft2{
            position: absolute;
            right: 10px;
            top: 140px;
            font-size: 12px;
            .ercode{
              p{
                white-space: nowrap;
              }
            }
            .ercode:nth-of-type(2){
              margin-top: 26px;

            }
          }
        }
      }
    }
    .contactRight{
      margin-left: 33px;
      width: 50%;
      .contactCompanyName, .contactNumber, .qq, .wx, .site {
        width: 100%;
        height: 50px;
        background: rgba(255,255,255,1);
        box-shadow: 0px 1px 6px rgba(0,0,0,0.06);
        opacity: 1;
        border-radius: 8px;
        margin-top: 15px;
        &.contactCompanyName{
          margin-top: 0;
        }
        input{
          line-height: 50px;
          width: 100%;
          font-size: 17px;
          border: none;
          height: 50px;
          background: rgba(0,0,0,0.01);
          box-shadow: 0px 3px 60px rgba(0,0,0,0.3);
          padding-left: 30px;
          border-radius: 8px;
          outline: none;
        }
      }
      .tips{
        font-size: 13px;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: rgba(255,0,0,1);
        opacity: 0.6;
        line-height: 40px;
      }
      .submit {
        height: 52px;
        background: rgba(252,95,53,1);
        opacity: 1;
        border-radius: 8px;
        color: #fff;
        text-align: center;
        line-height: 52px;
        margin-top: 0px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewestCase.vue